/**
 * The promo's marks: a check once it's applied, navy on the green, an arrow
 * to the form that earns it, white on the navy, and the sticky's ×.
 */

interface PromoIconProps {
  /** Width and height, in pixels. */
  size?: number
}

export function CheckIcon({ size = 22 }: PromoIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      aria-hidden="true"
      className="shrink-0 text-promo-ink"
    >
      <circle cx="11" cy="11" r="11" fill="currentColor" />
      <path
        d="m6.5 11.5 3 3 6-6.5"
        fill="none"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ArrowIcon({ size = 22 }: PromoIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      aria-hidden="true"
      className="shrink-0 text-white"
    >
      <circle cx="11" cy="11" r="11" fill="currentColor" />
      <path
        d="M6.5 11h9m-3.5-3.5L15.5 11 12 14.5"
        fill="none"
        stroke="var(--color-promo-night)"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function CloseIcon({ size = 14 }: PromoIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 14 14" aria-hidden="true" className="shrink-0">
      <path
        d="m1.5 1.5 11 11m0-11-11 11"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
    </svg>
  )
}
